import React, { useEffect, useState } from 'react'
import uploadImage from "../../images/upload-image.jpg";
import { CreateNewBrand } from "../../redux/Slices/BrandsSlice";
import { useDispatch, useSelector } from "react-redux";
import notify from "../UseNotification"

const UseAdminAddBrand = () => {
    const dispatch = useDispatch();
    const [BrandName, setBrandName] = useState();
    const [BrandImage, setBrandImage] = useState(uploadImage);
    const [selectedBrandImage, setSelectedBrandImage] = useState();
    const [loading, setLoading] = useState();
    const [isPress, setIsPress] = useState(false);
    const [isFormValid, setIsFormValid] = useState(false)
    const { AddBrand } = useSelector(state => state.BrandsReducer)

    // to save brand name
    const AddBrandName = (e) => {
        setBrandName(e.target.value);
    };

    // to save brand image
    const OnChangeBrandImage = (e) => {
        if (e.target.files && e.target.files[0]) {
            const readerImage = new FileReader()
            readerImage.readAsDataURL(e.target.files[0])
            readerImage.onloadend = (e) => {
                setBrandImage(readerImage.result)
                setSelectedBrandImage(readerImage.result)
            }
        }
    };


    // vaidate brand name
    const ValidateBrandName = (e) => {
        if (e.target.value === "") {
            notify("brand name must at least 2 character", "error")
        }
    }

    // validate brand image
    const ValidateBrandImage = () => {
        if (!selectedBrandImage) {
            notify("you must choose brand image", "error")
        }
    }

    // to handle disable submit button
    useEffect(() => {
        if (BrandName && selectedBrandImage && BrandName.length >= 3 && selectedBrandImage.name != "") {
            setIsFormValid(true)
        } else {
            setIsFormValid(false)
        }
    }, [BrandName, selectedBrandImage])
    // to convert images to base 64

    // function dataURLtoFile(dataurl, filename) {

    //     var arr = dataurl.split(','),
    //         mime = arr[0].match(/:(.*?);/)[1],
    //         bstr = atob(arr[1]),
    //         n = bstr.length,
    //         u8arr = new Uint8Array(n);

    //     while (n--) {
    //         u8arr[n] = bstr.charCodeAt(n);
    //     }

    //     return new File([u8arr], filename, { type: mime });
    // }

    // to submit form data
    const submitForm = async (e) => {
        e.preventDefault();
        setIsPress(true)
        if (BrandName?.length < 3) {
            notify("Brand Name must be at least 3 chars", "error")
            return;
        } else if (!selectedBrandImage) {
            notify("please choose the brand image", "error")
            return;
        }
        setLoading(true)
        // var BrandImageLink = dataURLtoFile(selectedBrandImage, Math.random() + ".png")
        const formData = new FormData();
        formData.append("name", BrandName);
        formData.append("image", selectedBrandImage);
        await dispatch(CreateNewBrand(formData));
        setLoading(false)
    };

    // to handle response request
    useEffect(() => {
        if (loading === false) {
            setIsPress(false)
            if (AddBrand && AddBrand.response) {
                if (AddBrand && AddBrand.response.status === 500) {
                    notify("Please complete the data", "error")
                } else if (AddBrand && AddBrand.response.status === 401) {
                    notify("Please login to can add new brand", "error")
                }
            } else if (AddBrand && AddBrand.status === 201) {
                notify("Brand Added", "success")
                window.location.reload(false)
            }
        }
    }, [loading])
    return [ValidateBrandName, ValidateBrandImage, isFormValid, isPress, loading, AddBrandName, OnChangeBrandImage, submitForm, BrandImage, BrandName]
}

export default UseAdminAddBrand
